import React from "react";
import s from "./Image.module.css";
import Link from "../_shared/Link";
import Spacing from "../_shared/Spacing";

const CLASSES_MAP = {
  "16/9": s.md,
  "1/1": s.lg,
  "32/10": s.sm,
};

function Image({ image, aspect_ratio, link, description, spacing }) {
  const ar = aspect_ratio || "16/9";

  return (
    <Spacing value={spacing}>
      <Link className={s.image_link} settings={link}>
        <img
          src={image}
          style={{
            aspectRatio: ar,
          }}
        />
        <div className={[s.content, CLASSES_MAP[ar]].join(" ")}>
          {link?.label && <div className={s.title}>{link?.label}</div>}
          {description && (
            <div
              className={s.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </Link>
    </Spacing>
  );
}

export default Image;
